import { DateTime } from 'luxon';

export const RelativeDateTimeMixin = {
  methods: {
    diffForHumans(date, locale = 'en') {
      return DateTime.fromISO(date).toRelative({ locale });
    },
  },
};
